/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerCheckEntitlementQueryResponse, OrganizationsControllerCheckEntitlementPathParams } from "../../models/organizationsController/OrganizationsControllerCheckEntitlement";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { organizationsControllerCheckEntitlement } from "../../clients/organizationsService/organizationsControllerCheckEntitlement";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const organizationsControllerCheckEntitlementQueryKey = (id: OrganizationsControllerCheckEntitlementPathParams["id"]) => [{
  url: '/api/v1/organizations/:id/entitlement',
  params: {
    id: id
  }
}] as const;
export type OrganizationsControllerCheckEntitlementQueryKey = ReturnType<typeof organizationsControllerCheckEntitlementQueryKey>;
export function organizationsControllerCheckEntitlementQueryOptions(id: OrganizationsControllerCheckEntitlementPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = organizationsControllerCheckEntitlementQueryKey(id);
  return queryOptions<OrganizationsControllerCheckEntitlementQueryResponse, ResponseErrorConfig<Error>, OrganizationsControllerCheckEntitlementQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return organizationsControllerCheckEntitlement(id, config);
    }
  });
}

/**
 * @summary Check organization Trimble EMS entitlement.
 * {@link /api/v1/organizations/:id/entitlement}
 */
export function useOrganizationsControllerCheckEntitlement<TData = OrganizationsControllerCheckEntitlementQueryResponse, TQueryData = OrganizationsControllerCheckEntitlementQueryResponse, TQueryKey extends QueryKey = OrganizationsControllerCheckEntitlementQueryKey>(id: OrganizationsControllerCheckEntitlementPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<OrganizationsControllerCheckEntitlementQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? organizationsControllerCheckEntitlementQueryKey(id);
  const query = useQuery({
    ...organizationsControllerCheckEntitlementQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}